/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
import ajax from 'helpers/ajax'
import { ThunkAction } from 'model/store/thunk'
import { Hall } from 'types/entities/Hall'
import { Language } from 'types/entities/Language'
import i18next from 'i18next'
import SessionAction from 'store/session/SessionAction'
import { setHall, setHallsList, setLanguage } from 'store/hall/HallReducer'

class HallAction {
    static fetchHall = (id?: number): ThunkAction<Promise<Response>, any> => {
        return (dispatch): Promise<any> => {
            return ajax
                .get('/halls' + (id ? '/detail/' + id : '/home'))
                .then((r: Hall) => {
                    dispatch(setHall(r as any))
                    return r
                })
        }
    }

    static fetchHalls = (): ThunkAction<Promise<Response>, any> => {
        return (dispatch, getState): Promise<any> => {
            return ajax.get('/halls/list').then((r) => {
                dispatch(setHallsList(r.halls))
            })
        }
    }

    static updateHomeHallId = (id): ThunkAction<Promise<Response>, any> => {
        return (dispatch, getState): Promise<any> => {
            return ajax
                .post('/user/update-profile', {
                    home_hall_id: id,
                })
                .then((r) => {
                    dispatch(SessionAction.fetchMe())
                    //dispatch(fetchRanking());
                    dispatch(SessionAction.fetchProfile())
                    window.location.reload()
                    return r
                })
        }
    }

    static setLanguage = (language: Language) => {
        return (dispatch, getState): Promise<any> => {
            i18next.changeLanguage(language.code).then((r) => {})
            return dispatch(setLanguage(language))
        }
    }
}

export default HallAction
